<template>
  <div>
    <div class="container">
      <div class="card rounded shadow my-3">
        <div class="card-body text-center">
          <img src="/media/checked.svg" class="w-25 mx-auto" alt="checked">
          <h3 class="text-success my-3">
            <b>پرداخت موفق</b>
          </h3>
<!--          -->
          <div class="container">
            <div class="row dir-rtl">
              <div class="col-4 p-0">
                <label class="w-100 text-black-50 text-right">
                  مبلغ پرداختی :
                </label>
              </div>
              <div class="col-8 p-0 text-left dir-ltr">
                {{info.increaseAmount | rial}}
<!--              -->
              </div>
              <div class="col-4 p-0">
                <label class="w-100 text-black-50 text-right">
                  رسید تراکنش :
                </label>
              </div>
              <div class="col-8 p-0 text-left">
                {{info.authority}}
<!--               -->
              </div>

              <div class="col-4 p-0">
                <label class="w-100 text-black-50 text-right">
                  تاریخ و ساعت :
                </label>
              </div>
              <div class="col-8 p-0 text-left dir-ltr">
                {{info.createdAt | longDate}}
<!--                -->
              </div>
              <div class="col-12 p-0">
                <a class="btn btn-success w-100" style="font-size: 16px" @click="openOrigin">
                  <i class="fa fa-check"></i>
                  <b>بازگشت به صفحه مرجع</b>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <label class="w-100 text-center text-black-50 dir-rtl" style="font-size: small">
        تمامی حقوق این نرم افزار برای ترمینال تبلیغات محفوظ است .
      </label>
    </div>
  </div>
</template>
<script >
  export default {
    props : {
      info: {
        type: Object,
        required: true
      }
    },
      methods:{
          openOrigin(){
              window.location.replace(this.info.callBack)
          },
      }
  }
</script>